import React from 'react';
import { ACCENT_FALLBACK } from './tokens';

// A two-generation pedigree fragment, marking both the launcher and the panel
// header so the button and the panel read as one object.
export function GeneratorMark({ size = 20, color = ACCENT_FALLBACK }) {
  return (
    <svg
      width={size}
      height={(size * 18) / 24}
      viewBox="0 0 24 18"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <g stroke={color} strokeWidth="1.4" fill="none" strokeLinecap="round">
        <rect x="2" y="1" width="6" height="6" />
        <circle cx="19" cy="4" r="3" />
        <path d="M8 4 H16" />
        <path d="M12 4 V11" />
        <rect x="9" y="11" width="6" height="6" />
      </g>
    </svg>
  );
}
